import { IErrorDetail } from '~commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '~commonInfra/contentActions/MultipleItemResult';
import { LensErrorCode } from '~commonInfra/utils/ErrorCodes';

import { Messages } from '../../codegen/Localize';
import { ILensBase } from '../models/ILensInfo';

export class LensErrors {
  public static errorDetailsFor(LensErrorItem: IErrorItem<ILensBase>): IErrorDetail {
    return {
      itemName: LensErrorItem.item.name,
      itemUrl: null, // TODO: Have URL if the item exists.
      errorMessage: LensErrors.errorMessageFor(LensErrorItem)
    };
  }

  public static errorMessageFor(errorItem: IErrorItem<ILensBase>) {
    const lens = errorItem.item;
    const errorCode = errorItem.error.code;

    switch (errorCode) {
      case LensErrorCode.LensNameExistsInDestinationProject:
        return Messages.errorLensNameAlreadyExists();
      default:
        return Messages.errorUnknown();
    }
  }
}
